import Vue from 'vue'
import Router from 'vue-router'
import HomeIndex from '@/views/home/index'
import KrHomeIndex from '@/views/home/lang/kr/index'
import privacy from '@/views/policy/index'
import recharge from '@/views/recharge/index'
import payment from '@/views/recharge/payment'
import paymentSuccess from '@/views/recharge/success'
import paymentFailure from '@/views/recharge/failure'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'HomeIndex',
      component: HomeIndex
    },
    {
      path: '/kr',
      name: 'HomeIndex',
      component: KrHomeIndex
    },
    {
      path: '/privacypolicy',
      name: 'privacyPolicy',
      component: privacy
    },
    {
      path: '/termsofservice',
      name: 'termsService',
      component: privacy
    },
    {
      path: '/shop',
      component: recharge,
      name: 'Recharge'
    },
    {
      path: '/shop/payment',
      component: payment,
      name: 'Payment'
    },
    {
      path: '/shop/payment/success',
      component: paymentSuccess,
      name: 'PaymentSuccess'
    },
    {
      path: '/shop/payment/failure',
      component: paymentFailure,
      name: 'PaymentFailure'
    },
    {
      path: '/wpwoyrn5q8',
      redirect: { name: 'Recharge' }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js